import React, { useEffect } from 'react'
import { useToggle } from '../../hooks'
import Portal from '../Portal'
import { ModalBodyWrapper, ModalWrapper, ModalBody } from './styled'

const Modal = ({ autoClose, renderOpenButton, children }) => {
    const [isOpen, toggleIsOpen] = useToggle(false)
    useEffect(() => {
        if(autoClose && isOpen)  {
            toggleIsOpen();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoClose])
    return (
        <>
            {
                renderOpenButton && renderOpenButton({ handleToggleIsOpenModal: toggleIsOpen })
            }
            <Portal
                id='modal-root'
            >
                {
                    isOpen &&
                    <ModalWrapper
                        onClick={toggleIsOpen}
                    >
                        <ModalBodyWrapper>
                            <ModalBody onClick={event => event.stopPropagation()}>
                                {children && children({ handleToggleIsOpenModal: toggleIsOpen })}
                            </ModalBody>
                        </ModalBodyWrapper>
                    </ModalWrapper>
                }
            </Portal>
        </>
    )
}

export default Modal